import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

// PAGE NAVBAR 
import Home from '../Pages/Home'
import AboutUs from '../Pages/AboutUs'
import Portfolio from '../Pages/Portfolio'
import Artikel from '../Pages/Artikel'
import Contact from '../Pages/Contact'

// PAGE PROJECT
import Architecture from '../Pages/Architecture'
import InteriorDesign from '../Pages/InteriorDesign'
import Construction from '../Pages/Construction'

const Router = () => {
  return (
    <BrowserRouter>
        <Routes>
          {/* PAGE NAVBAR */}
            <Route path="/" element={<Home />}/>
            <Route path="/aboutus" element={<AboutUs />}/>
            <Route path="/portfolio" element={<Portfolio />}/>
            <Route path="/article" element={<Artikel />}/>
            <Route path="/contact" element={<Contact />}/>

          {/* PAGE PROJECT */}
          <Route path="/arsitektur" element={<Architecture />}/>
          <Route path="/interior-design" element={<InteriorDesign />}/>
          <Route path="/konstruksi" element={<Construction />}/>
        </Routes>
    </BrowserRouter>
  )
}

export default Router